import { money, revenueColumns } from './revenueData';

export default function RevenueCurrencyTable({ rows, publisher, selectedCode, onSelect }) {
    const columns = revenueColumns(publisher);
    return <div className="revenue-table-wrap" role="region" aria-label="Revenue by currency" tabIndex={0}>
        <table className="revenue-table">
            <caption className="revenue-sr-only">Revenue totals by recorded currency for the selected period</caption>
            <thead><tr><th scope="col">Currency</th>{columns.map(([key, label]) => <th scope="col" key={key}>{label}</th>)}</tr></thead>
            <tbody>{rows.map((row) => <tr key={row.currency.code} className={row.currency.code === selectedCode ? 'is-selected' : ''}>
                <th scope="row"><button type="button" onClick={() => onSelect(row.currency.code)} aria-pressed={row.currency.code === selectedCode} aria-label={`Show ${row.currency.code} breakdown`}>
                    <span className="revenue-code">{row.currency.code}</span><span className="revenue-table-name">{row.currency.label || row.currency.code}</span>
                </button></th>
                {columns.map(([key, label]) => <td key={key} data-label={label}>{money(row, key)}</td>)}
            </tr>)}</tbody>
        </table>
    </div>;
}
